{
  "App": "Aplikacja",
  "Profile": "Profil",
  "My Account": "Moje konto",
  "Contacts": "Kontakty",
  "Preferences": "Preferencje",
  "Family Language": "Język rodzinny",
  "Program Consent": "Zgoda na program",
  "Yes": "Tak",
  "No": "Nie",
  "Not submitted": "Nie przesłano",
  "See anything missing? Contact your Caring Adult": "Czegoś brakuje? Skontaktuj się ze swoim Wspierającym dorosłym",
  "Messages": "Wiadomości",
  "Caring Adult for": "Wspierający dorosły dla:",
  "Former Caring Adult for": "Były Wspierający dorosły dla:",
  "Write your message here...": "Tutaj napisz wiadomość...",
  "I need help with": "Potrzebuję pomocy w następujących obszarach",
  "Academic": "Nauka",
  "After School/ Out of School": "Po szkole/poza szkołą",
  "Applying for benefits": "Ubieganie się o świadczenia",
  "Childcare": "Opieka nad dzieckiem",
  "Employment / Adult Education": "Zatrudnienie/edukacja dorosłych",
  "Food": "Żywność",
  "Housing": "Zakwaterowanie",
  "Legal services": "Usługi prawne",
  "Material Resources / Clothing / Laundry": "Zasoby materialne/odzież/pranie",
  "Mental/emotional health": "Zdrowie psychiczne/emocjonalne",
  "Physical health/asthma": "Zdrowie fizyczne/astma",
  "Transportation": "Transport",
  "Send": "Wyślij",
  "Today": "Dzisiaj",
  "No messages yet": "Nie ma jeszcze wiadomości",
  "No messages": "Brak wiadomości",
  "Start a conversation below": "Rozpocznij rozmowę poniżej",
  "This Caring Adult is no longer available": "Ten Wspierający dorosły nie jest już dostępny",
  "No longer available ": "Już niedostępny ",
  "Monday": "Poniedziałek",
  "Tuesday": "Wtorek",
  "Wednesday": "Środa",
  "Thursday": "Czwartek",
  "Friday": "Piątek",
  "Saturday": "Sobota",
  "Sunday": "Niedziela",
  "Emergency Contacts": "Kontakt w nagłych wypadkach",
  "Supervisor of Social Workers for the Bronx": "Kierownik pracowników socjalnych w Bronksie",
  "Student Services Manager, High School District": "Kierownik ds. usług uczniowskich, okręg szkół średnich",
  "Social Worker, Central Crisis Support Team": "Pracownik socjalny, Centralny Zespół Wsparcia Kryzysowego (Central Crisis Support Team)",
  "Support Line": "Infolinia wsparcia",
  "Suicide and Crisis Lifeline": "Infolinia wsparcia dla osób w kryzysie samobójczym lub innym (Suicide and Crisis Lifeline)",
  "Emergencies": "Nagłe wypadki",
  "If you are facing a life-threatening emergency and need help right now, call or text 911": "Jeśli jesteś w sytuacji zagrażającej życiu i potrzebujesz natychmiastowej pomocy, zadzwoń lub wyślij SMS-a pod numer 911",
  "About New Visions": "O New Visions",
  "Privacy and Terms": "Prywatność i warunki",
  "Homepage": "Strona główna",
  "Home Page": "Strona główna",
  "My family": "Moja rodzina",
  "Available Services": "Dostępne usługi",
  "Grade": "Klasa",
  "School": "Szkoła",
  "Attendance this year": "Obecność w tym roku",
  "Absences last 5 days": "Nieobecności z ostatnich 5 dni",
  "Caring Adult": "Wspierający dorosły",
  "Message": "Wiadomość",
  "Not available": "Niedostępny",
  "Not yet assigned": "Jeszcze nieprzypisany",
  "No absences": "Brak nieobecności",
  "Phone not available": "Telefon niedostępny",
  "Email address not available": "Adres e-mail niedostępny",
  "January": "Styczeń",
  "February": "Luty",
  "March": "Marzec",
  "April": "Kwiecień",
  "May": "Maj",
  "June": "Czerwiec",
  "July": "Lipiec",
  "August": "Sierpień",
  "September": "Wrzesień",
  "October": "Październik",
  "November": "Listopad",
  "December": "Grudzień",
  "Sidenav": "Pasek boczny",
  "Home": "Strona główna",
  "Log out": "Wyloguj",
  "Accessibility": "Ułatwienia dostępu",
  "Skip to main content": "Przejdź do głównej zawartości",
  "Email": "E-mail",
  "Phone": "Telefon",
  "Family Portal": "Portal rodzinny",
  "Every Child and Family is Known": "Każde Dziecko i Rodzina Są Znane",
  "Family Portal: Every Child and Family is Known": "Portal rodzinny: Każde Dziecko i Rodzina Są Znane",
  "Close menu": "Zamknij menu",
  "Open menu": "Otwórz menu",
  "Notes": "Uwagi",
  "Send message": "Wyślij wiadomość",
  "Languages": "Języki",
  "Consent status": "Status zgody",
  "Select": "Wybierz",
  "Language selector": "Wybór języka",
  "Sorry": "Niestety",
  "we couldn't find that page": "nie znaleziono tej strony",
  "You are not yet authorized to log in to the Family Portal. Please reach out to your Caring Adult for access.": "Nie masz jeszcze uprawnień do logowania się do Portalu Rodzinnego. Aby uzyskać dostęp, skontaktuj się ze swoją troskliwą osobą dorosłą."
}